// Route configuration for the application
const routes = {
  // Public routes
  public: {
    LOGIN: '/login',
    REGISTER: '/register',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    VERIFY_OTP: '/verify-otp',
    MARKETS_CONTAINER: '/markets-container',
  },
  
  // Protected routes
  protected: {
    DASHBOARD: '/dashboard',
    MARKETS: '/markets',
    TRADE: '/trade',
    WALLET: '/wallet',
    PROFILE: '/profile',
    SETTINGS: '/settings',
  }
};

export default routes; 